import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route, Switch, withRouter} from "react-router-dom";
import TestTemplateReports from "./TestTemplateReports";

function mapStateToProps(state) {
  return {};
}

class TestTemplateReportsIndex extends Component {
  render() {
    return (
      <Switch>
        <Route component={TestTemplateReports} path="/test-template-reports/:guid"/>
      </Switch>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
)(TestTemplateReportsIndex));
